/**
 * Funkcja sprawdzająca czy adres email jest poprawny. 
 * > Polskie znaki nie są dozwolone w adresie
 * > Nie może zaczynać się od ".", liczby lub innego niedozwolonego znaku
 * > Musi posiadać znak "@"
 * > Domena musi mieć długość pomiędzy 2 a 4 znakami
 * @param emailToCheck 
 * @returns 
 */

import { ValidationError } from 'yup'

export const isEmailValid = {
   name: 'isEmailValid',
   message: 'Nieprawidłowa wartość',
   test: (emailToCheck: string | undefined) => {
      if(emailToCheck?.length){
         const emailRegexp = /^[a-zA-Z1-9]{1,1}[\w-.]+@([a-zA-Z1-9]+\.)+[a-zA-Z]{2,4}$/g
   
         return emailRegexp.test(emailToCheck)
      }
      else {
         return false
      }
   }
}

/**
 * Funkcja sprawdzająca czy email z pola "Email" jest taki sam jak email z pola "ConfirmEmail". 
 * Funkcja ignoruje wielkość znaków
 */
export const isEmailEqualCustomValidation = (confirmEmailFieldValue: string | undefined, emailFieldValue: string | undefined) => {  
   if(confirmEmailFieldValue === undefined || confirmEmailFieldValue?.length === 0) {
      throw new ValidationError('Nieprawidłowa wartość')
   }
   
   if(Boolean(confirmEmailFieldValue?.toLowerCase().trim() !== emailFieldValue?.toLowerCase().trim())){
      throw new ValidationError("Adresy e-mail nie zgadzają się")
   }

   else {
      return true
   }
}